import React from 'react'
import './parking.css'
var noParking = require('../../../theme/assets/images/parkingTypes/No-parking.png')
var driveWayParking = require('../../../theme/assets/images/parkingTypes/Driveway-parking.png')
var onStreetParking = require('../../../theme/assets/images/parkingTypes/Street-parking.png')

function Parking(props) {
  return (
    <div>
      {props.bikeData.bike_parking == 'no_parking' && (
        <div className="no-parking-wrapper">
          <div className='is-flex is-align-items-center'>
            <b className="bike-profile-subHeading">Available Parking</b>
            <i class="fa-solid fa-square-parking ml-2 mt-1"></i>
          </div>
          <div className="parking-status">
            <div className="bike-parking-type">
              <img src={noParking} className="no-parking"></img>
              <p className="is-paragraph-text">No Parking Available</p>
            </div>
          </div>
        </div>
      )}
      {props.bikeData.bike_parking == 'driveway' && (
        <div className="driveway-parking-wrapper">
          <div className='is-flex is-align-items-center'>
            <b className="bike-profile-subHeading">Available Parking</b>
            <i class="fa-solid fa-square-parking ml-2 mt-1"></i>
          </div>
          <div className="parking-status">
            <div className="bike-parking-type">
              <img src={driveWayParking} className="driveWay-parking"></img>
              <p className="is-paragraph-text">Driveway Parking Available</p>
            </div>
          </div>
        </div>
      )}
      {props.bikeData.bike_parking == 'street' && (
        <div className="street-parking-wrapper">
          <div className='is-flex is-align-items-center'>
            <b className="bike-profile-subHeading">Available Parking</b>
            <i class="fa-solid fa-square-parking ml-2 mt-1"></i>
          </div>
          <div className="parking-status">
            <div className="bike-parking-type">
              <img src={onStreetParking} className="on-street-parking"></img>
              <p className="street-parking-status is-paragraph-text">
                Street Parking Available
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Parking
